import { IComboBoxValue } from "../models/form";

export function getEventFields(removeFields: IComboBoxValue[] = []): IComboBoxValue[]
{
    var fields: IComboBoxValue[] = [
        {
            selectedValue: "Betreff",
            value: "Betreff"
        },
        {
            selectedValue: "Kalender",
            value: "Kalender"
        },
        {
            selectedValue: "Status",
            value: "Status"
        },
        {
            selectedValue: "Anzeigetyp",
            value: "Anzeigetyp"
        },
        {
            selectedValue: "Startdatum",
            value: "Startdatum"
        },
        {
            selectedValue: "Zeit von",
            value: "Zeit von"
        },
        {
            selectedValue: "Zeit bis",
            value: "Zeit bis"
        },
        {
            selectedValue: "Rüstzeit davor",
            value: "Rüstzeit davor"
        },
        {
            selectedValue: "Rüstzeit danach",
            value: "Rüstzeit danach"
        },
        {
            selectedValue: "Bestattungsart",
            value: "Bestattungsart"
        },
        {
            selectedValue: "Grabnummer",
            value: "Grabnummer"
        },
        {
            selectedValue: "Grabart",
            value: "Grabart"
        },
        {
            selectedValue: "Bestatter",
            value: "Bestatter"
        },
        {
            selectedValue: "Pfarrer",
            value: "Pfarrer"
        },
        {
            selectedValue: "Trauerhalle",
            value: "Trauerhalle"
        },
        {
            selectedValue: "Anzahl Trauergäste",
            value: "Anzahl Trauergäste"
        },
        {
            selectedValue: "Bemerkung",
            value: "Bemerkung"
        },
        {
            selectedValue: "Bemerkung 2",
            value: "Bemerkung 2"
        },
        {
            selectedValue: "Nachname (Verstorbener)",
            value: "Nachname (Verstorbener)"
        },
        {
            selectedValue: "Vorname (Verstorbener)",
            value: "Vorname (Verstorbener)"
        },
        {
            selectedValue: "Geburtsname (Verstorbener)",
            value: "Geburtsname (Verstorbener)"
        },
        {
            selectedValue: "Geburtsdatum (Verstorbener)",
            value: "Geburtsdatum (Verstorbener)"
        },
        {
            selectedValue: "Sterbedatum (Verstorbener)",
            value: "Sterbedatum (Verstorbener)"
        },
        {
            selectedValue: "Sterbeort (Verstorbener)",
            value: "Sterbeort (Verstorbener)"
        },
        {
            selectedValue: "Konfession (Verstorbener)",
            value: "Konfession (Verstorbener)"
        },
        {
            selectedValue: "Anrede (Ansprechpartner)",
            value: "Anrede (Ansprechpartner)"
        },
        {
            selectedValue: "Nachname (Ansprechpartner)",
            value: "Nachname (Ansprechpartner)"
        },
        {
            selectedValue: "Vorname (Ansprechpartner)",
            value: "Vorname (Ansprechpartner)"
        },
        {
            selectedValue: "Straße (Ansprechpartner)",
            value: "Straße (Ansprechpartner)"
        },
        {
            selectedValue: "Hausnummer (Ansprechpartner)",
            value: "Hausnummer (Ansprechpartner)"
        },
        {
            selectedValue: "Land (Ansprechpartner)",
            value: "Land (Ansprechpartner)"
        },
        {
            selectedValue: "PLZ (Ansprechpartner)",
            value: "PLZ (Ansprechpartner)"
        },
        {
            selectedValue: "Ort (Ansprechpartner)",
            value: "Ort (Ansprechpartner)"
        },
        {
            selectedValue: "Rufnummer (Ansprechpartner)",
            value: "Rufnummer (Ansprechpartner)"
        }
    ];

    if (fields.length > 0)
        fields.removeAt(item => removeFields.any(f => f.selectedValue === item.selectedValue));

    return fields;
}